import Model from './model.js';

export default class SelfEmployment extends Model
{
    constructor(id, personId, profession, workplace, experienceYear, note){ 
        super()
        this.id             = id ?? 0;
        this.personId       = personId;
        this.profession     = profession;
        this.workplace      = workplace;
        this.experienceYear = experienceYear;
        this.note           = note;
        
        this.init()
    }

    update(data){
        Object.assign(this, data)
    }
   
    mapToUpdate(){
        let data =  {
            profession:     this.profession ?? null,
            workPlace:      this.workplace ?? null,
            experienceYear: this.experienceYear ?? null,
            note:           this.note ?? null,
        }
        return data;
    }
 
    mapToCreate(){
        let data = this.mapToUpdate();
        
        data.personId = this.personId ?? null;
        return data;
    }
}

